"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadButtonVariants = exports.UploadButtonVariantTypes = exports.UploadButtonSizes = void 0;
var _types = require("../Button/types");
var UploadButtonVariants = _types.ButtonVariants;
exports.UploadButtonVariants = UploadButtonVariants;
var UploadButtonVariantTypes = _types.ButtonVariantTypes;
exports.UploadButtonVariantTypes = UploadButtonVariantTypes;
var UploadButtonSizes = _types.ButtonSizes;
exports.UploadButtonSizes = UploadButtonSizes;